import { setLoading, setGlobalMessage } from '../../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../../../api_exception';

import RFQ_FIELDS_PART_0 from 'eebac/constants/fields/compnay/rfq/rfq_part_0';
import RFQ_FIELDS_PART_1 from 'eebac/constants/fields/compnay/rfq/rfq_part_1';
import RFQ_FIELDS_PART_2 from 'eebac/constants/fields/compnay/rfq/rfq_part_2';
import RFQ_FIELDS_PART_3 from 'eebac/constants/fields/compnay/rfq/rfq_part_3';
import RFQ_FIELDS_PART_4 from 'eebac/constants/fields/compnay/rfq/rfq_part_4';
import RFQ_FIELDS_PART_5 from 'eebac/constants/fields/compnay/rfq/rfq_part_5';
import RFQ_FIELDS_PART_6 from 'eebac/constants/fields/compnay/rfq/rfq_part_6';
import RFQ_FIELDS_PART_7 from 'eebac/constants/fields/compnay/rfq/rfq_part_7';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import { setRfqInfoData } from '../../rfq_info';

const BASE_PATH = "COMPANY_WORK_POSTS";

export const loadPosts = (rowsPerPage = null, page = null, clearExisting = true, resetFilters = false) =>
    (dispatch, getState, client) => {

        let state = getState().COMPANY_WORK_POSTS;
        let filters = [];

        if (!resetFilters) {
            if (state.state) {
                filters.push({ name: "state", values: [state.state] });
            }

            if (state.city && Array.isArray(state.city) && state.city.length > 0) {
                filters.push({ name: "city", values: state.city });
            }

            if (state.firmType && Array.isArray(state.firmType) && state.firmType.length > 0) {
                filters.push({ name: "firmType", values: state.firmType });
            }

            if (state.workType && Array.isArray(state.workType) && state.workType.length > 0) {
                filters.push({ name: "workType", values: state.workType });
            }

            if (state.status) {
                filters.push({ name: "status", values: [state.status] });
            }
        }

        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1
        }

        if (filters.length > 0) {
            apiData.filters = filters;
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        if (clearExisting) {
            dispatch(setPostsData([], 0, apiData.itemsCount, 0));
        }

        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        client.post('/company/work_posts', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.posts) {
                    dispatch(setPostsData(result.data.posts,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }

export const loadPost = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/company/work_post/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.post) {
                    dispatch(setPostData(result.data.post));
                    dispatch(viewPost(true));
                } else {
                    dispatch(setPostData(null));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(viewPost(false));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setPostData(null));
            });
    }

export const deletePost = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.delete(`/company/work_post/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(loadPosts());
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const editPost = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/company/work_post_edit/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.post) {
                    let FIELDS = {
                        ...RFQ_FIELDS_PART_0,
                        ...RFQ_FIELDS_PART_1,
                        ...RFQ_FIELDS_PART_2,
                        ...RFQ_FIELDS_PART_3,
                        ...RFQ_FIELDS_PART_4,
                        ...RFQ_FIELDS_PART_5,
                        ...RFQ_FIELDS_PART_6,
                        ...RFQ_FIELDS_PART_7
                    };

                    FIELDS.id = id;

                    let postData = result.data.post;
                    postData.id = id;

                    ApiDataHelper.set(
                        (data) => dispatch(setRfqInfoData(data)), postData, FIELDS);

                    dispatch(setEditPost(true));

                } else {
                    dispatch(setEditPost(false));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setEditPost(false));
            });
    }

export const activePost = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.put(`/company/work_post/active/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(loadPosts());
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const deActivePost = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.put(`/company/work_post/deactive/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(loadPosts());
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }


export const SET_POSTS_DATA = `${BASE_PATH}/SET_POSTS_DATA`;
export const SET_FILTERS_DATA = `${BASE_PATH}/SET_FILTERS_DATA`;
export const SET_POST = `${BASE_PATH}/SET_POST`;
export const VIEW_POST = `${BASE_PATH}/VIEW_POST`;
export const OPEN_POST = `${BASE_PATH}/OPEN_POST`;
export const EDIT_POST = `${BASE_PATH}/EDIT_POST`;
export const OPEN_CONFIRM_DIALOG = `${BASE_PATH}/OPEN_CONFIRM_DIALOG`;
export const OPEN_SCHEDULE = `${BASE_PATH}/OPEN_SCHEDULE`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;

export const setPostsData = (posts, page, rowsPerPage, totalRows) => ({
    type: SET_POSTS_DATA,
    posts,
    page,
    rowsPerPage,
    totalRows
});

export const viewPost = (open) => ({
    type: VIEW_POST,
    open
});

export const setEditPost = (edit) => ({
    type: EDIT_POST,
    edit
});

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    data
});

export const setPostData = (data) => ({
    type: SET_POST,
    data
});

export const openPost = (open) => ({
    type: OPEN_POST,
    open
});

export const openConfirmDialog = (open, selectedPostId) => ({
    type: OPEN_CONFIRM_DIALOG,
    open,
    selectedPostId
});

export const openSchedule = (open, selectedSchedulePostId) => ({
    type: OPEN_SCHEDULE,
    open,
    selectedSchedulePostId
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    posts: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,

    state: '',
    city: [],
    firmType: [],
    workType: [],

    stateError: '',
    cityError: '',
    firmTypeError: '',
    workTypeError: '',

    viewPost: false,
    openPost: false,
    editPost: false,
    postData: null,
    openConfirmDialog: false,
    openSchedule: false,
    selectedSchedulePostId: null,
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_POSTS_DATA:
            newState = {
                ...state,
                posts: [...action.posts],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_FILTERS_DATA:
            newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VIEW_POST:
            return { ...state, viewPost: action.open };
        case EDIT_POST:
            return { ...state, editPost: action.edit };
        case OPEN_POST:
            return { ...state, openPost: action.open };
        case SET_POST:
            return {
                ...state,
                postData: action.data
            }
        case OPEN_CONFIRM_DIALOG:
            return {
                ...state,
                openConfirmDialog: action.open,
                selectedPostId: action.selectedPostId
            }
        case OPEN_SCHEDULE:
            return {
                ...state,
                openSchedule: action.open,
                selectedSchedulePostId: action.selectedSchedulePostId
            }
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}